import { Slice as CreateScheduleSlice } from "../redux/Slice";

export { CreateScheduleSlice };
